import api from './api';

export const expenseService = {
  getAll: (params?: any) => api.get('/expenses', { params }),
  getById: (id: number) => api.get(`/expenses/${id}`),
  create: (data: any) => api.post('/expenses', data),
  update: (id: number, data: any) => api.put(`/expenses/${id}`, data),
  delete: (id: number) => api.delete(`/expenses/${id}`),
  approve: (id: number) => api.post(`/expenses/${id}/approve`),
  markAsPaid: (id: number) => api.post(`/expenses/${id}/mark-paid`),
  getCategories: () => api.get('/expenses-categories'),
  getStats: (params?: any) => api.get('/expenses-stats', { params })
};